import { getCompatibleAveryTemplates, isStandardAverySheetTemplate } from "./averyTemplates";

const getAveryDetails = (template) => `Aliases: ${template.aliases.join(", ")}`;

const getAveryFormats = (size) => {
  const templates = getCompatibleAveryTemplates(size).filter(isStandardAverySheetTemplate);

  return templates.reduce((acc, template) => {
    const labelWidth = template.template_cell?.w_mm ?? template.label.w_mm;
    const labelHeight = template.template_cell?.h_mm ?? template.label.h_mm;

    acc[template.id] = {
      width: template.paper.w_mm,
      height: template.paper.h_mm,
      label: `Avery ${template.aliases[0]} (${template.region})`,
      details: getAveryDetails(template),
      layout: {
        type: "avery",
        cols: template.grid.cols,
        rows: template.grid.rows,
        labelWidth,
        labelHeight,
        marginLeft: template.margins.left_mm,
        marginTop: template.margins.top_mm,
        gapX: template.gaps.x_mm,
        gapY: template.gaps.y_mm,
      },
    };

    return acc;
  }, {});
};

export const getPaperFormats = (size) => {
  const isHorizontalBadge = size.widthInMm > size.heightInMm;

  return {
    // Exact mm (not ceil): worker places badges with size.widthInMm/heightInMm; rounding up
    // left slack that getLayoutConfig turned into extra gaps / visible margins.
    badge: {
      width: size.widthInMm,
      height: size.heightInMm,
      name: "Badge size",
      label: "Badge size",
    },
    "badge-double-width": {
      width: size.widthInMm * 2,
      height: size.heightInMm,
      name: "Double width badge",
      label: "Double width badge",
    },
    "badge-double-height": {
      width: size.widthInMm,
      height: size.heightInMm * 2,
      name: "Double height badge",
      label: "Double height badge",
    },

    ...getAveryFormats(size),

    a4: {
      width: isHorizontalBadge ? 297 : 210,
      height: isHorizontalBadge ? 210 : 297,
      label: "A4",
    },
    a3: {
      width: isHorizontalBadge ? 420 : 297,
      height: isHorizontalBadge ? 297 : 420,
      label: "A3",
    },
    a5: {
      width: isHorizontalBadge ? 210 : 148,
      height: isHorizontalBadge ? 148 : 210,
      label: "A5",
    },
    a6: {
      width: isHorizontalBadge ? 148 : 105,
      height: isHorizontalBadge ? 105 : 148,
      label: "A6",
    },
    b4: {
      width: isHorizontalBadge ? 353 : 250,
      height: isHorizontalBadge ? 250 : 353,
      label: "B4",
    },
    b5: {
      width: isHorizontalBadge ? 250 : 176,
      height: isHorizontalBadge ? 176 : 250,
      label: "B5",
    },
    letter: {
      width: isHorizontalBadge ? 279.4 : 215.9,
      height: isHorizontalBadge ? 215.9 : 279.4,
      label: "US Letter",
    },
    legal: {
      width: isHorizontalBadge ? 355.6 : 215.9,
      height: isHorizontalBadge ? 215.9 : 355.6,
      label: "US Legal",
    },
    tabloid: {
      width: isHorizontalBadge ? 431.8 : 279.4,
      height: isHorizontalBadge ? 279.4 : 431.8,
      label: "Tabloid",
    },
  };
};
